import { FilterRegular, ChevronDownRegular, ChevronUpRegular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { BasicButton } from '@components/common/BasicButton';
import { useSpaceFilterToggleStyles } from './SpaceFilterToggle.styles';

export interface SpaceFilterToggleProps {
  expanded: boolean;
  onClick: () => void;
}

export const SpaceFilterToggle: React.FC<SpaceFilterToggleProps> = ({ expanded, onClick }) => {
  const styles = useSpaceFilterToggleStyles();
  const { t } = useTranslation('bookingForm');

  const ChevronIcon = expanded ? ChevronUpRegular : ChevronDownRegular;

  return (
    <BasicButton
      className={styles.root}
      variant="secondary"
      size="medium"
      icon={<FilterRegular />}
      onClick={onClick}
      data-testid="space-filter-toggle"
    >
      {t('bookingForm.spaceFilter.toggleLabel')}
      <ChevronIcon />
    </BasicButton>
  );
};

SpaceFilterToggle.displayName = 'SpaceFilterToggle';
